// extracted by mini-css-extract-plugin
module.exports = {"container":"IppicaCarousel_container__IcnDk","navigationContainer":"IppicaCarousel_navigationContainer__4zNBx","title":"IppicaCarousel_title__annQE"};